module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Binocular-fea50cc4895a863537fe72d1e25833ef.svg";